var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkDesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.1735,
    r: 12,
    fill: "#5B78FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2497 15.0202L15.4128 13.8571C15.5685 13.7014 15.7664 13.5947 15.9821 13.5504C16.1978 13.5061 16.4218 13.5261 16.6263 13.6078L18.0428 14.1749C18.2516 14.2584 18.4305 14.4026 18.5566 14.5888C18.6826 14.775 18.75 14.9947 18.75 15.2196V17.7956C18.7504 17.9487 18.7195 18.1002 18.6592 18.241C18.599 18.3818 18.5106 18.5087 18.3996 18.6142C18.2886 18.7196 18.1572 18.8013 18.0136 18.8542C17.8699 18.9071 17.7169 18.9301 17.564 18.9218C7.63494 18.3039 5.62959 9.89419 5.25729 6.67381C5.23926 6.51638 5.25476 6.3569 5.30278 6.20589C5.35081 6.05487 5.43025 5.91573 5.53591 5.79762C5.64156 5.67951 5.77102 5.58511 5.91577 5.52062C6.06052 5.45614 6.21729 5.42302 6.37576 5.42347H8.90606C9.13093 5.42346 9.35065 5.49083 9.53686 5.61689C9.72308 5.74294 9.86726 5.9219 9.95079 6.13068L10.5173 7.54719C10.599 7.75165 10.619 7.97561 10.5747 8.19132C10.5304 8.40702 10.4238 8.60498 10.2681 8.76067L9.10493 9.92378C9.10493 9.92378 9.74984 14.4579 14.2497 15.0202Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkDesk);
export default __webpack_public_path__ + "static/media/Link-desk.3b13f3e3.svg";
export { ForwardRef as ReactComponent };